// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactDates = require("react-dates");
var JsxRuntime = require("react/jsx-runtime");
var DataType$ReactHooksTemplate = require("./dataType.res.js");
var DateType$ReactHooksTemplate = require("./dateType.res.js");
var ListType$ReactHooksTemplate = require("./listType.res.js");
var TextType$ReactHooksTemplate = require("./textType.res.js");
var DataField$ReactHooksTemplate = require("./dataField.res.js");
var EmailType$ReactHooksTemplate = require("./emailType.res.js");
var MsisdnType$ReactHooksTemplate = require("./msisdnType.res.js");
var NumberType$ReactHooksTemplate = require("./numberType.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var ReactDatePicker$ReactHooksTemplate = require("../common/ReactDatePicker.res.js");

function DataFieldForm(props) {
  var selectedDataField = props.selectedDataField;
  var onFormSubmit = props.onFormSubmit;
  var match = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var match$1 = React.useState(function (param) {
        return selectedDataField;
      });
  var setDataField = match$1[1];
  var dataField = match$1[0];
  var match$2 = React.useState(function (param) {
        return false;
      });
  var setErrors = match$2[1];
  var errors = match$2[0];
  var match$3 = React.useState(function (param) {
        return null;
      });
  var setFocusedInput = match$3[1];
  var match$4 = React.useState(function (param) {
        return "";
      });
  var setInputValue = match$4[1];
  var inputValue = match$4[0];
  var containsInvalidChar = function (specialCharRegex, words) {
    return List.exists((function (word) {
                  return List.exists((function (x) {
                                return Caml_obj.equal(word, x);
                              }), specialCharRegex);
                }), words);
  };
  var handleDataTypeChange = function (e) {
    var name = e.target.value;
    Curry._1(setDataField, (function (param) {
            return DataField$ReactHooksTemplate.setDataType(dataField, DataType$ReactHooksTemplate.dataTypeFromName(name));
          }));
  };
  var handleListTypeOptionsChange = function (listTypeField, options) {
    Curry._1(setDataField, (function (param) {
            return DataField$ReactHooksTemplate.setDataType(dataField, {
                        TAG: "ListType",
                        _0: ListType$ReactHooksTemplate.setOptions(listTypeField, options)
                      });
          }));
  };
  var handleEmailTypeDomainsChange = function (emailTypeField, domains) {
    Curry._1(setDataField, (function (param) {
            return DataField$ReactHooksTemplate.setDataType(dataField, {
                        TAG: "EmailType",
                        _0: EmailType$ReactHooksTemplate.setDomains(emailTypeField, domains)
                      });
          }));
  };
  var handleNameChange = function (e) {
    var name = e.target.value;
    var words = Belt_List.fromArray(Js_string.split("", name));
    var error = containsInvalidChar({
          hd: "<",
          tl: {
            hd: "!",
            tl: {
              hd: "=",
              tl: {
                hd: "+",
                tl: {
                  hd: "-",
                  tl: {
                    hd: "@",
                    tl: {
                      hd: ">",
                      tl: {
                        hd: "?",
                        tl: {
                          hd: "'",
                          tl: {
                            hd: "\"",
                            tl: {
                              hd: "$",
                              tl: {
                                hd: "#",
                                tl: {
                                  hd: "%",
                                  tl: {
                                    hd: "^",
                                    tl: {
                                      hd: "*",
                                      tl: {
                                        hd: "(",
                                        tl: {
                                          hd: ")",
                                          tl: {
                                            hd: "/",
                                            tl: {
                                              hd: ".",
                                              tl: {
                                                hd: "&",
                                                tl: {
                                                  hd: ",",
                                                  tl: {
                                                    hd: ";",
                                                    tl: {
                                                      hd: "`",
                                                      tl: {
                                                        hd: "~",
                                                        tl: /* [] */0
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }, words);
    Curry._1(setErrors, (function (param) {
            return error;
          }));
    Curry._1(setDataField, (function (param) {
            return DataField$ReactHooksTemplate.setName(dataField, name);
          }));
  };
  var numberTypeField = DataField$ReactHooksTemplate.dataType(dataField);
  var isValidMin;
  if (numberTypeField.TAG === "NumberType") {
    var numberTypeField$1 = numberTypeField._0;
    var match$5 = NumberType$ReactHooksTemplate.min(numberTypeField$1);
    var match$6 = NumberType$ReactHooksTemplate.max(numberTypeField$1);
    isValidMin = match$5 !== undefined ? (
        match$6 !== undefined ? match$6 >= match$5 : false
      ) : true;
  } else {
    isValidMin = true;
  }
  var msisdnTypeField = DataField$ReactHooksTemplate.dataType(dataField);
  var isValidLength;
  switch (msisdnTypeField.TAG) {
    case "MsisdnType" :
        var length = MsisdnType$ReactHooksTemplate.length(msisdnTypeField._0);
        isValidLength = length !== undefined ? length > 0 : false;
        break;
    case "TextType" :
        var length$1 = TextType$ReactHooksTemplate.length(msisdnTypeField._0);
        isValidLength = length$1 !== undefined ? length$1 > 0 : false;
        break;
    default:
      isValidLength = true;
  }
  var isValidName = DataField$ReactHooksTemplate.name(dataField).length > 0 && !errors;
  var isValidForm = isValidName && isValidLength && isValidMin;
  var listTypeField = DataField$ReactHooksTemplate.dataType(dataField);
  var tmp;
  switch (listTypeField.TAG) {
    case "ListType" :
        var listTypeField$1 = listTypeField._0;
        tmp = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("label", {
                      children: "Options",
                      className: "block text-sm font-medium text-gray-700 mb-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("input", {
                              className: "w-full border-none outline-none focus:ring-0 text-sm",
                              maxLength: 100,
                              placeholder: "Type an option and press Enter",
                              type: "text",
                              value: inputValue,
                              onKeyDown: (function ($$event) {
                                  var value = inputValue.trim();
                                  if (!($$event.key === "Enter" && value !== "")) {
                                    return ;
                                  }
                                  $$event.preventDefault();
                                  var currentOptions = ListType$ReactHooksTemplate.options(listTypeField$1);
                                  if (Belt_List.has(currentOptions, value, (function (a, b) {
                                            return a === b;
                                          }))) {
                                    return ;
                                  }
                                  var updatedOptions = List.append(currentOptions, {
                                        hd: value,
                                        tl: /* [] */0
                                      });
                                  handleListTypeOptionsChange(listTypeField$1, updatedOptions);
                                  Curry._1(setInputValue, (function (param) {
                                          return "";
                                        }));
                                }),
                              onChange: (function (e) {
                                  Curry._1(setInputValue, (function (param) {
                                          return e.target.value;
                                        }));
                                })
                            }),
                        JsxRuntime.jsx("div", {
                              children: $$Array.of_list(Belt_List.mapWithIndex(ListType$ReactHooksTemplate.options(listTypeField$1), (function (index, tag) {
                                          return JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("span", {
                                                              children: tag
                                                            }),
                                                        JsxRuntime.jsx("button", {
                                                              children: "×",
                                                              className: "ml-2 text-blue-500 hover:text-blue-700 font-bold",
                                                              onClick: (function (param) {
                                                                  var updatedOptions = Belt_List.keepWithIndex(ListType$ReactHooksTemplate.options(listTypeField$1), (function (param, i) {
                                                                          return index !== i;
                                                                        }));
                                                                  handleListTypeOptionsChange(listTypeField$1, updatedOptions);
                                                                })
                                                            })
                                                      ],
                                                      className: "inline-flex items-center bg-blue-100 text-blue-700 text-sm px-3 py-1 rounded-lg"
                                                    }, String(index + 1 | 0));
                                        }))),
                              className: "flex flex-wrap gap-2 mt-2"
                            })
                      ],
                      className: "bg-white border border-gray-300 rounded-lg p-3"
                    }),
                JsxRuntime.jsx("p", {
                      children: "Add options for the list selection by typing and pressing Enter",
                      className: "mt-1 text-xs text-gray-500"
                    })
              ]
            });
        break;
    case "NumberType" :
        var numberTypeField$2 = listTypeField._0;
        var min = NumberType$ReactHooksTemplate.min(numberTypeField$2);
        var max = NumberType$ReactHooksTemplate.max(numberTypeField$2);
        tmp = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Minimum Value",
                              className: "block text-sm font-medium text-gray-700 mb-2"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 " + (
                                isValidMin ? "border-gray-300" : "border-red-300"
                              ),
                              placeholder: "Enter minimum value (optional)",
                              type: "number",
                              value: min !== undefined ? String(min) : "",
                              onChange: (function (param) {
                                  var min = param.target.value;
                                  return Curry._1(setDataField, (function (param) {
                                                return DataField$ReactHooksTemplate.setDataType(dataField, {
                                                            TAG: "NumberType",
                                                            _0: NumberType$ReactHooksTemplate.setMin(numberTypeField$2, min)
                                                          });
                                              }));
                                })
                            }),
                        isValidMin ? null : JsxRuntime.jsx("p", {
                                children: "Minimum should be less than maximum",
                                className: "mt-1 text-xs text-red-600"
                              })
                      ]
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Maximum Value",
                              className: "block text-sm font-medium text-gray-700 mb-2"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200",
                              placeholder: "Enter maximum value (optional)",
                              type: "number",
                              value: max !== undefined ? String(max) : "",
                              onChange: (function (param) {
                                  var max = param.target.value;
                                  return Curry._1(setDataField, (function (param) {
                                                return DataField$ReactHooksTemplate.setDataType(dataField, {
                                                            TAG: "NumberType",
                                                            _0: NumberType$ReactHooksTemplate.setMax(numberTypeField$2, max)
                                                          });
                                              }));
                                })
                            })
                      ]
                    })
              ],
              className: "space-y-4"
            });
        break;
    case "EmailType" :
        var emailTypeField = listTypeField._0;
        tmp = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("label", {
                      children: "Allowed Domains",
                      className: "block text-sm font-medium text-gray-700 mb-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("input", {
                              className: "w-full border-none outline-none focus:ring-0 text-sm",
                              maxLength: 100,
                              placeholder: "Type a domain and press Enter (e.g., example.com)",
                              type: "text",
                              value: inputValue,
                              onKeyDown: (function ($$event) {
                                  var value = inputValue.trim();
                                  if (!($$event.key === "Enter" && value !== "")) {
                                    return ;
                                  }
                                  $$event.preventDefault();
                                  var currentDomains = EmailType$ReactHooksTemplate.domains(emailTypeField);
                                  if (Belt_List.has(currentDomains, value, (function (a, b) {
                                            return a === b;
                                          }))) {
                                    return ;
                                  }
                                  var updatedDomains = List.append(currentDomains, {
                                        hd: value,
                                        tl: /* [] */0
                                      });
                                  handleEmailTypeDomainsChange(emailTypeField, updatedDomains);
                                  Curry._1(setInputValue, (function (param) {
                                          return "";
                                        }));
                                }),
                              onChange: (function (e) {
                                  Curry._1(setInputValue, (function (param) {
                                          return e.target.value;
                                        }));
                                })
                            }),
                        JsxRuntime.jsx("div", {
                              children: $$Array.of_list(Belt_List.mapWithIndex(EmailType$ReactHooksTemplate.domains(emailTypeField), (function (index, domain) {
                                          return JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("span", {
                                                              children: domain
                                                            }),
                                                        JsxRuntime.jsx("button", {
                                                              children: "×",
                                                              className: "ml-2 text-orange-500 hover:text-orange-700 font-bold",
                                                              onClick: (function (param) {
                                                                  var updatedDomains = Belt_List.keepWithIndex(EmailType$ReactHooksTemplate.domains(emailTypeField), (function (param, i) {
                                                                          return index !== i;
                                                                        }));
                                                                  handleEmailTypeDomainsChange(emailTypeField, updatedDomains);
                                                                })
                                                            })
                                                      ],
                                                      className: "inline-flex items-center bg-orange-100 text-orange-700 text-sm px-3 py-1 rounded-lg"
                                                    }, String(index + 1 | 0));
                                        }))),
                              className: "flex flex-wrap gap-2 mt-2"
                            })
                      ],
                      className: "bg-white border border-gray-300 rounded-lg p-3"
                    }),
                JsxRuntime.jsx("p", {
                      children: "Add domains to restrict email addresses (e.g., example.com)",
                      className: "mt-1 text-xs text-gray-500"
                    })
              ]
            });
        break;
    case "DateType" :
        var dateTypeField = listTypeField._0;
        tmp = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("label", {
                      children: "Date Range",
                      className: "block text-sm font-medium text-gray-700 mb-2"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ReactDates.DateRangePicker, {
                            className: "w-full",
                            startDate: DateType$ReactHooksTemplate.startDate(dateTypeField),
                            startDateId: "data_field_start_date",
                            endDate: DateType$ReactHooksTemplate.endDate(dateTypeField),
                            endDateId: "data_field_end_date",
                            disabled: false,
                            onDatesChange: (function (param) {
                                var rangeTuple = ReactDatePicker$ReactHooksTemplate.DateRangeTuple.getDates(param);
                                var selectedStartDate = Caml_option.some(ReactDatePicker$ReactHooksTemplate.DateRangeTuple.getStartDate(rangeTuple));
                                var selectedEndDate = Caml_option.some(ReactDatePicker$ReactHooksTemplate.DateRangeTuple.getEndDate(rangeTuple));
                                return Curry._1(setDataField, (function (param) {
                                              return DataField$ReactHooksTemplate.setDataType(dataField, {
                                                          TAG: "DateType",
                                                          _0: DateType$ReactHooksTemplate.setDateRange(dateTypeField, selectedStartDate, selectedEndDate)
                                                        });
                                            }));
                              }),
                            focusedInput: Caml_option.some(match$3[0]),
                            onFocusChange: (function (focusedInput) {
                                Curry._1(setFocusedInput, (function (param) {
                                        return focusedInput;
                                      }));
                              }),
                            displayFormat: "DD/MM/YYYY",
                            openDirection: "up",
                            hideKeyboardShortcutsPanel: true,
                            enableOutsideDays: true,
                            isOutsideRange: (function (param) {
                                return false;
                              }),
                            small: true,
                            orientation: "horizontal",
                            numberOfMonths: 1,
                            readOnly: true,
                            minimumNights: 0
                          }),
                      className: "bg-white border border-gray-300 rounded-lg p-3"
                    }),
                JsxRuntime.jsx("p", {
                      children: "Select the allowed date range for this field",
                      className: "mt-1 text-xs text-gray-500"
                    })
              ]
            });
        break;
    case "MsisdnType" :
        var msisdnTypeField$1 = listTypeField._0;
        var length$2 = MsisdnType$ReactHooksTemplate.length(msisdnTypeField$1);
        var countryCode = MsisdnType$ReactHooksTemplate.countryCode(msisdnTypeField$1);
        tmp = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Length",
                              className: "block text-sm font-medium text-gray-700 mb-2"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 " + (
                                isValidLength ? "border-gray-300" : "border-red-300"
                              ),
                              min: "1",
                              placeholder: "Enter phone number length",
                              type: "number",
                              value: length$2 !== undefined ? String(length$2) : "",
                              onChange: (function (param) {
                                  var length = param.target.value;
                                  return Curry._1(setDataField, (function (param) {
                                                return DataField$ReactHooksTemplate.setDataType(dataField, {
                                                            TAG: "MsisdnType",
                                                            _0: MsisdnType$ReactHooksTemplate.setLength(msisdnTypeField$1, length)
                                                          });
                                              }));
                                })
                            }),
                        isValidLength ? null : JsxRuntime.jsx("p", {
                                children: "Length must be greater than zero",
                                className: "mt-1 text-xs text-red-600"
                              })
                      ]
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Country Code",
                              className: "block text-sm font-medium text-gray-700 mb-2"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200",
                              maxLength: 100,
                              placeholder: "Enter country code (e.g., +1)",
                              type: "text",
                              value: countryCode !== undefined ? countryCode : "",
                              onChange: (function (param) {
                                  var countryCode = param.target.value;
                                  return Curry._1(setDataField, (function (param) {
                                                return DataField$ReactHooksTemplate.setDataType(dataField, {
                                                            TAG: "MsisdnType",
                                                            _0: MsisdnType$ReactHooksTemplate.setCountryCode(msisdnTypeField$1, countryCode)
                                                          });
                                              }));
                                })
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Optional: Add country code prefix",
                              className: "mt-1 text-xs text-gray-500"
                            })
                      ]
                    })
              ],
              className: "space-y-4"
            });
        break;
    case "TextType" :
        var textTypeField = listTypeField._0;
        var length$3 = TextType$ReactHooksTemplate.length(textTypeField);
        tmp = JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("label", {
                      children: "Maximum Length",
                      className: "block text-sm font-medium text-gray-700 mb-2"
                    }),
                JsxRuntime.jsx("input", {
                      className: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 " + (
                        isValidLength ? "border-gray-300" : "border-red-300"
                      ),
                      min: "1",
                      placeholder: "Enter maximum length",
                      type: "number",
                      value: length$3 !== undefined ? String(length$3) : "",
                      onChange: (function (param) {
                          var length = param.target.value;
                          return Curry._1(setDataField, (function (param) {
                                        return DataField$ReactHooksTemplate.setDataType(dataField, {
                                                    TAG: "TextType",
                                                    _0: TextType$ReactHooksTemplate.setLength(textTypeField, length)
                                                  });
                                      }));
                        })
                    }),
                isValidLength ? JsxRuntime.jsx("p", {
                        children: "Set the maximum character length for this text field",
                        className: "mt-1 text-xs text-gray-500"
                      }) : JsxRuntime.jsx("p", {
                        children: "Length must be greater than zero",
                        className: "mt-1 text-xs text-red-600"
                      })
              ]
            });
        break;
    
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "Field Name",
                                      className: "block text-sm font-medium text-gray-700 mb-2"
                                    }),
                                JsxRuntime.jsx("input", {
                                      className: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 " + (
                                        DataField$ReactHooksTemplate.name(dataField).length === 0 || errors ? "border-red-300" : "border-gray-300"
                                      ),
                                      maxLength: 100,
                                      placeholder: "Enter field name",
                                      type: "text",
                                      value: DataField$ReactHooksTemplate.name(dataField),
                                      onChange: handleNameChange
                                    }),
                                DataField$ReactHooksTemplate.name(dataField).length === 0 ? JsxRuntime.jsx("p", {
                                        children: "Name can't be empty",
                                        className: "mt-1 text-xs text-red-600"
                                      }) : (
                                    errors ? JsxRuntime.jsx("p", {
                                            children: "Special characters are not allowed",
                                            className: "mt-1 text-xs text-red-600"
                                          }) : null
                                  )
                              ]
                            }),
                        JsxRuntime.jsx("div", {
                              children: props.updateForm ? JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Data Type",
                                              className: "block text-sm font-medium text-gray-700 mb-2"
                                            }),
                                        JsxRuntime.jsx("input", {
                                              className: "w-full px-3 py-2 border border-gray-300 bg-gray-100 rounded-lg text-sm text-gray-500 cursor-not-allowed capitalize",
                                              disabled: true,
                                              type: "text",
                                              value: DataType$ReactHooksTemplate.dataTypeName(DataField$ReactHooksTemplate.dataType(dataField))
                                            }),
                                        JsxRuntime.jsx("p", {
                                              children: "Data type cannot be changed after creation",
                                              className: "mt-1 text-xs text-gray-500"
                                            })
                                      ]
                                    }) : JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Data Type",
                                              className: "block text-sm font-medium text-gray-700 mb-2"
                                            }),
                                        JsxRuntime.jsx("select", {
                                              children: $$Array.of_list(List.map((function (option) {
                                                          return JsxRuntime.jsx("option", {
                                                                      children: option,
                                                                      value: option
                                                                    }, option);
                                                        }), DataType$ReactHooksTemplate.dataTypeNames)),
                                              className: "w-full px-3 py-2 border border-gray-300 bg-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 capitalize",
                                              value: DataType$ReactHooksTemplate.dataTypeName(DataField$ReactHooksTemplate.dataType(dataField)),
                                              onChange: handleDataTypeChange
                                            })
                                      ]
                                    })
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("h3", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: "⚙️",
                                              className: "mr-2"
                                            }),
                                        "Type-Specific Configuration"
                                      ],
                                      className: "text-sm font-medium text-gray-900 mb-4 flex items-center"
                                    }),
                                tmp
                              ],
                              className: "bg-gradient-to-r from-gray-50 to-blue-50 rounded-lg p-4 border border-gray-200"
                            }),
                        Curry._1(match[0], "MaskValues") ? JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                        checked: DataField$ReactHooksTemplate.masked(dataField),
                                        label: "Mask this field",
                                        handleChange: (function (param) {
                                            Curry._1(setDataField, (function (param) {
                                                    return DataField$ReactHooksTemplate.setMasked(dataField, !DataField$ReactHooksTemplate.masked(dataField));
                                                  }));
                                          }),
                                        labelClassName: "text-sm font-medium text-gray-700 leading-normal"
                                      }),
                                  JsxRuntime.jsx("p", {
                                        children: "Hidden for everyone except users with Mask values or View mask values. Live surveys and customer messages are not affected.",
                                        className: "mt-2 text-xs text-gray-500"
                                      })
                                ],
                                className: "bg-white rounded-lg p-4 border border-gray-200"
                              }) : null
                      ],
                      className: "p-6 space-y-6"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: "Cancel",
                              className: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                              onClick: props.toggleModal
                            }),
                        JsxRuntime.jsx("button", {
                              children: "Save Field",
                              className: "px-6 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 " + (
                                isValidForm ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
                              ),
                              disabled: !isValidForm,
                              onClick: (function (param) {
                                  Curry._1(onFormSubmit, dataField);
                                })
                            })
                      ],
                      className: "bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end space-x-3"
                    })
              ],
              className: "flex flex-col"
            });
}

var make = DataFieldForm;

exports.make = make;
/* react Not a pure module */
